<template>
  <div style="padding: 10px">
    <!-- 搜索区域 -->
    <div style="margin: 10px 0; display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">
      <!-- 用户搜索 -->
      <el-select
          v-model="search.roleId"
          placeholder="请选择用户"
          filterable
          remote
          clearable
          :remote-method="handleSearchAccountInfo"
          :loading="searchAccountLoading"
          @focus="handleAccountSelectFocus"
          style="width: 200px"
      >
        <el-option
            v-for="item in accountInfoOptions"
            :key="item.roleId"
            :label="item.accountName"
            :value="item.roleId">
          <span>{{ item.accountName }} ({{ item.roleId }})</span>
        </el-option>
      </el-select>

      <!-- 交易情况选择 -->
      <el-select
          v-model="search.type"
          placeholder="交易情况"
          clearable
          style="width: 150px"
      >
        <el-option label="收入" :value="0"></el-option>
        <el-option label="支出" :value="1"></el-option>
        <el-option label="代售未结算" :value="2"></el-option>
        <el-option label="代售已结算" :value="3"></el-option>
      </el-select>

      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button @click="resetData">重置</el-button>
      <!-- 新增按钮 -->
      <el-button type="primary" @click="handleAdd">新增</el-button>
      <!-- 计算按钮 -->
      <el-button type="success" @click="calculateStatistics">计算</el-button>
    </div>

    <!-- 统计数据显示 -->
    <div v-if="showStatistics"
         style="margin: 10px 0; padding: 15px; background: #303133; border: 1px solid #303133; border-radius: 4px;">
      <div style="display: flex; font-size: 14px; gap: 50px; flex-wrap: wrap;">
        <div>
          <span style="font-weight: bold; color: #606266;">总支出：</span>
          <span style="color: #f56c6c; font-weight: bold;">{{ statistics.outMoney }}元</span>
        </div>
        <div>
          <span style="font-weight: bold; color: #606266;">总收入：</span>
          <span style="color: #67c23a; font-weight: bold;">{{ statistics.inMoney }}元</span>
        </div>
        <div>
          <span style="font-weight: bold; color: #606266;">待结算：</span>
          <span style="color: #e6a23c; font-weight: bold;">{{ statistics.otherMoney }}元</span>
        </div>
        <div>
          <span style="font-weight: bold; color: #606266;">净利润：</span>
          <span style="color: #409eff; font-weight: bold;">{{ statistics.income }}元</span>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="角色名"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="roleId"
          label="角色ID"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="price"
          label="交易金额"
          show-overflow-tooltip>
        <template #default="scope">
          {{ formatNumber(scope.row.price) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="type"
          label="交易情况"
          show-overflow-tooltip>
        <template #default="scope">
          <el-tag :type="getTypeTagType(scope.row.type)">
            {{ getTypeText(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="event"
          label="说明"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="160px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" @click="end(scope.row)">结算</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <!-- 新增时显示账号选择 -->
        <el-form-item v-if="!form.id" label="账号" prop="roleId" required>
          <el-select
              v-model="form.roleId"
              placeholder="请选择账号"
              filterable
              remote
              clearable
              :remote-method="handleSearchAccountInfo"
              :loading="searchAccountLoading"
              @focus="handleAccountSelectFocus"
              @change="handleAccountChange"
              style="width: 100%">
            <el-option
                v-for="item in accountInfoOptions"
                :key="item.roleId"
                :label="item.accountName"
                :value="item.roleId">
              <span>{{ item.accountName }} ({{ item.roleId }})</span>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 编辑时显示账号信息（只读） -->
        <el-form-item v-if="form.id" label="角色名">
          <el-input v-model="form.accountName" readonly style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item v-if="form.id" label="角色ID">
          <el-input v-model="form.roleId" readonly style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item label="交易金额" prop="price" required>
          <el-input-number
              v-model="form.price"
              :min="0"
              :precision="2"
              style="width: 100%"
              placeholder="请输入交易金额">
          </el-input-number>
        </el-form-item>

        <el-form-item label="交易情况" prop="type" required>
          <el-select v-model="form.type" placeholder="请选择交易情况" style="width: 100%">
            <el-option label="收入" :value="0"></el-option>
            <el-option label="支出" :value="1"></el-option>
            <el-option label="代售未结算" :value="2"></el-option>
            <el-option label="代售已结算" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="说明" prop="event">
          <el-input
              v-model="form.event"
              type="textarea"
              :rows="2"
              placeholder="请输入说明"
              style="width: 100%">
          </el-input>
        </el-form-item>

        <el-form-item label="时间" prop="createTime" required>
          <el-date-picker
              v-model="form.createTime"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="YYYY-MM-DD HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacySoldManagement',
  components: {},
  data() {
    return {
      userId: '',
      loading: true,
      search: {
        roleId: '',
        type: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      dialogVisible: false,
      dialogTitle: '新增',
      form: {
        id: null,
        accountName: '',
        roleId: '',
        price: 0,
        type: 0,
        event: '',
        createTime: ''
      },
      formRef: null,

      // 账号搜索相关
      accountInfoOptions: [],
      searchAccountLoading: false,
      searchAccountDebounce: null,

      // 统计相关
      showStatistics: false,
      statistics: {
        outMoney: 0,      // 总支出
        inMoney: 0,       // 总收入
        otherMoney: 0,    // 待结算
        income: 0         // 净利润
      },

      // 表单验证规则
      rules: {
        roleId: [
          {required: true, message: '请选择账号', trigger: 'blur'}
        ],
        price: [
          {required: true, message: '请输入交易金额', trigger: 'blur'},
          {type: 'number', min: 0, message: '金额不能为负数', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择交易情况', trigger: 'change'}
        ],
        createTime: [
          {required: true, message: '请选择时间', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    // 初始化用户信息
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;

    // 加载数据
    this.load();
  },
  methods: {
    // 重置搜索条件
    resetData() {
      this.search = {
        roleId: '',
        type: ''
      };
      this.currentPage = 1;
      this.load();
    },

    // 计算统计信息
    calculateStatistics() {
      this.loading = true;

      request.get("/legacySoldOrder/computeMoney")
          .then(res => {
            this.loading = false;
            if (res.code === '0') {
              const data = res.data || {};
              this.updateStatistics(data);
              this.showStatistics = true;
              this.$message({
                type: "success",
                message: "计算完成"
              });
            } else {
              this.$message.error(res.msg || '计算失败');
            }
          })
          .catch(error => {
            this.loading = false;
            console.error('计算统计信息失败:', error);
            this.$message.error('网络错误，计算失败');
          });
    },

    // 更新统计数据显示
    updateStatistics(data) {
      this.statistics = {
        outMoney: this.formatNumber(data.outMoney || 0),
        inMoney: this.formatNumber(data.inMoney || 0),
        otherMoney: this.formatNumber(data.otherMoney || 0),
        income: this.formatNumber(data.income || 0)
      };
    },

    // 格式化数字，保留两位小数
    formatNumber(num) {
      return parseFloat(num.toFixed(2));
    },

    // 获取交易情况标签类型
    getTypeTagType(type) {
      switch (parseInt(type)) {
        case 0:
          return 'success'; // 收入
        case 1:
          return 'danger';  // 支出
        case 2:
          return 'warning'; // 代售未结算
        case 3:
          return 'info';   // 代售已结算
        default:
          return 'info';
      }
    },

    // 获取交易情况文本
    getTypeText(type) {
      const typeMap = {
        0: '收入',
        1: '支出',
        2: '代售未结算',
        3: '代售已结算'
      };
      return typeMap[type] || '未知';
    },

    // 点击新增按钮
    handleAdd() {
      this.dialogTitle = '新增';
      this.form = {
        id: null,
        accountName: '',
        roleId: '',
        price: 0,
        type: 0,
        event: '',
        createTime: this.getCurrentTime()
      };
      this.dialogVisible = true;
    },

    // 点击编辑按钮
    handleEdit(row) {
      this.dialogTitle = '编辑';
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },

    // 处理账号搜索
    handleSearchAccountInfo(query) {
      this.searchAccountLoading = true;

      // 清除之前的防抖计时器
      if (this.searchAccountDebounce) {
        clearTimeout(this.searchAccountDebounce);
      }

      // 设置新的防抖计时器
      this.searchAccountDebounce = setTimeout(() => {
        this.performSearchAccount(query);
      }, 300);
    },

    // 实际执行搜索
    performSearchAccount(accountName) {
      request.get("/accountInfo/searchAccounts", {
        params: {
          accountName: accountName,
          limit: 20
        }
      }).then(res => {
        this.searchAccountLoading = false;
        if (res.code === '0') {
          this.accountInfoOptions = res.data;
        } else {
          this.accountInfoOptions = [];
        }
      }).catch(error => {
        this.searchAccountLoading = false;
        console.error('搜索账号失败:', error);
        this.accountInfoOptions = [];
      });
    },

    // 选择框获得焦点时的处理
    handleAccountSelectFocus() {
      // 如果还没有数据，自动搜索前20条记录
      if (this.accountInfoOptions.length === 0) {
        this.handleSearchAccountInfo('');
      }
    },

    // 账号选择变化时的处理
    handleAccountChange(roleId) {
      if (roleId) {
        const selectedAccount = this.accountInfoOptions.find(item => item.roleId === roleId);
        if (selectedAccount) {
          this.form.accountName = selectedAccount.accountName;
        }
      } else {
        this.form.accountName = '';
      }
    },

    // 获取当前时间
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 保存表单
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          const formData = {...this.form};

          if (formData.id) {
            // 编辑 - 不允许更新角色名和角色ID
            const updateData = {
              id: formData.id,
              price: formData.price,
              type: formData.type,
              event: formData.event,
              createTime: formData.createTime
            };

            request.post("/legacySoldOrder/update", updateData).then(res => {
              this.loading = false;
              if (res.code === '0') {
                this.$message({
                  type: "success",
                  message: "编辑成功"
                });
                this.dialogVisible = false;
                this.load();
                // 重新计算统计信息
                if (this.showStatistics) {
                  this.calculateStatistics();
                }
              } else {
                this.$message({
                  type: "error",
                  message: res.msg || "编辑失败"
                });
              }
            }).catch(error => {
              this.loading = false;
              this.$message.error("网络错误，编辑失败");
            });
          } else {
            // 新增
            request.post("/legacySoldOrder/save", formData).then(res => {
              this.loading = false;
              if (res.code === '0') {
                this.$message({
                  type: "success",
                  message: "新增成功"
                });
                this.dialogVisible = false;
                this.load();
                // 重新计算统计信息
                if (this.showStatistics) {
                  this.calculateStatistics();
                }
              } else {
                this.$message({
                  type: "error",
                  message: res.msg || "新增失败"
                });
              }
            }).catch(error => {
              this.loading = false;
              this.$message.error("网络错误，新增失败");
            });
          }
        }
      });
    },
    // 结算
    end(row) {
      this.loading = true;

      const updateData = {
        id: row.id,
        type: 3,
      };

      request.post("/legacySoldOrder/update", updateData).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "结算完成"
          });
          this.load();
          // 重新计算统计信息
          if (this.showStatistics) {
            this.calculateStatistics();
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg || "结算失败"
          });
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error("网络错误，结算失败");
      });
    },

    // 加载数据
    load() {
      this.loading = true;

      // 构建查询参数
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      Object.keys(this.search).forEach(key => {
        if (this.search[key] !== '' && this.search[key] !== undefined && this.search[key] !== null) {
          params[key] = this.search[key];
        }
      });

      request.get("/legacySoldOrder/listPage", {
        params: params
      }).then(res => {
        this.loading = false;

        if (res.code === '0') {
          const data = res.data;
          this.tableData = data.records || [];
          this.total = data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
.el-select {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}

/* 统计信息样式 */
.statistics-container {
  margin: 10px 0;
  padding: 15px;
  background: #303133;
  border: 1px solid #303133;
  border-radius: 4px;
}

.statistics-line {
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
